import { cyberpunkPreset } from "./presets/cyberpunk"
import { flThemePreset } from "./presets/fl-theme"
import { sageMistPreset } from "./presets/sage-mist"
import { defaultPreset, type ThemePreset } from "./tokens"

/** Registry of built-in presets, by key. */
export const presets: Record<string, ThemePreset> = {
  default: defaultPreset,
  cyberpunk: cyberpunkPreset,
  "sage-mist": sageMistPreset,
  "fl-theme": flThemePreset,
}

export const DEFAULT_PRESET_KEY = "default"

/** Look up a preset by key, falling back to the default preset. */
export function getPreset(key: string | undefined): ThemePreset {
  if (key && presets[key]) {
    return presets[key]
  }
  return presets[DEFAULT_PRESET_KEY]
}

/** Preset list for admin pickers. */
export function listPresets(): ThemePreset[] {
  return Object.values(presets)
}
